

import { getNewsAndEvents } from '../data-utils';
import $ from 'jquery';
import App from '../app';
import * as D from '~/data-utils';
import HistoryAPI from '../history';
let history = new HistoryAPI();
var newsdata = {};

function init(context){
  var news = getNews(); //get all offers or only offers from current category if currentCategory is set
  var orderedNews = setNewsOrder(news);
  var keywords = getKeywords();
  var langs = D.langs();
  var lang = D.lang();
  var translations = App.getTranslations(langs);
  var currentArticle = getCurrentArticle();

  newsdata = {
    news: orderedNews,
    keywords: keywords || {},
    currentKeyword: '',
    currentNews: '',
    showByKeyword: 0,
    iconsvg: context.resources.get('ic_news'),
    icontitle: translations[lang]['common.eventsAndNews'],
    currentLang: lang,
    translations: translations,
    lastposition: 0,
    currentposition: 0
  };

  history = new HistoryAPI('#news', {
    iconsvg: newsdata.iconsvg,
    translations
  });

  if(typeof currentArticle != 'object') {
    showFullContent(currentArticle);
    App.removeStoredData('currentArticle', 'all');
  }

  return newsdata;
}

function getNewsdata(){
  return newsdata;
}

function getCurrentArticle(){
  var currentArticle = App.getStoredData('currentArticle', 'all');
  return currentArticle;
}

function sortAlphabetically(obj){
  var lang = D.lang();
  return obj.sort((a, b) => a.localeCompare(b, lang, { sensitivity: 'base' }));
}

function getUniqueValues(array){
  var uniqueItems = [];
  $.map(array, function(item){
    if($.inArray(item, uniqueItems) == -1)
      uniqueItems.push(item.trim());
  });
  return uniqueItems;
}

function getNews(){
  return getNewsAndEvents().map(item => {
    item.imagecount = item.images ? item.images.length : 0;
    return item;
  });
}
function setNewsOrder(news){
  if(news.length > 0){
    var orderedNews = orderByTime(news);
    orderedNews = sortToColumns(orderedNews);
    news = orderedNews;
  }
  return news;
}
function orderByTime(news){
  news.sort(function(a, b) {
    a = new Date(a.publishDate);
    b = new Date(b.publishDate);
    return a>b ? -1 : a<b ? 1 : 0;
  });
  return news;
}

function sortToColumns(news){
  var count = 0;
  var columnCount = 3;
  var orderedNews = [];
  var round = 0;

  if(news.length < 3){
    columnCount = news.length;
  }

  while(round < columnCount){
    orderedNews[round] = [];
    orderedNews[round].push(news[0]);

    $.each(news, function(i, item){
      if(count == columnCount){
        orderedNews[round].push(item);
        count=0;
      }
      count++;
      if(i == news.length-1){
        news.shift();
        count=0;
        round++;
      }
    });
  }

  return orderedNews;
}

function getKeywords(){
  var lang = D.lang();
  var newsfeed = App.getStoredData('news', lang);
  var keywords = $.map(newsfeed.news, function(item){
    if(item.keywords){
      return item.keywords;
    }
  });

  var uniqueKeywords = getUniqueValues(keywords);
  var orderedKeywords = sortAlphabetically(uniqueKeywords);
  return orderedKeywords;
}

function setKeyword(key){
  newsdata.showByKeyword=0;
  if(key=='all-events'){
    newsdata.keyword='';
    var allNews = getNews();
    newsdata.news = setNewsOrder(allNews);
  }else{
    newsdata.currentKeyword = key;
    setNewsByKeyword(key);
  }
}

function setNewsByKeyword(id){
  var allNews = getNews();
  var newsbykeyword = $.map(allNews, function(news){
    if(news.keywords){
      var trimmedKeywords = $.map(news.keywords, function(keyword){
        return keyword.trim();
      });
      if($.inArray(id, trimmedKeywords) > -1){
        return news;
      }
    }
  });

  newsbykeyword = setNewsOrder(newsbykeyword);

  newsdata.news = newsbykeyword;
}

function setPosition(position){
  newsdata.lastposition = newsdata.currentposition;
  newsdata.currentposition = position;
}

function showFullContent (id) {
  newsdata.currentposition = 0;
  newsdata.currentNews = $.map(newsdata.news, function(column){
    var item = column.find(function (item) {
      if(item.id==id){
        return item;
      }
    });

    return item;
  });
}

function toggleShowByKeyword(){
  if(newsdata.showByKeyword==0){
    newsdata.showByKeyword=1;
    newsdata.currentKeyword = '';
    newsdata.lastposition = newsdata.currentposition;
    newsdata.currentposition = 0;
  }else{
    newsdata.showByKeyword=0;
    newsdata.currentposition = newsdata.lastposition;
  }
}

function updateState(){
  history.updateState(newsdata);
}

function saveState() {
  history.saveState(newsdata);
}

async function goBack() {
  const [historyState, state] = await history.goBackAsync();
  newsdata = state || newsdata;
  return !!historyState;
}

export default {
  init,
  getNews,
  getNewsdata,
  getKeywords,
  setKeyword,
  showFullContent,
  toggleShowByKeyword,
  setPosition,
  updateState,
  saveState,
  goBack
};
